import { render, staticRenderFns } from "./accountQuery.vue?vue&type=template&id=1021475a&scoped=true&"
import script from "./accountQuery.vue?vue&type=script&lang=js&"
export * from "./accountQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021475a",
  null
  
)

export default component.exports